/* eslint-disable class-methods-use-this */
import ContractEntity, {
  ContractWDH,
} from 'utils/__interfaces/Perimeter/ContractEntity'

class ContractNormalizer {
  normalize(contratList: ContractWDH[]): ContractEntity[] {
    return contratList.map((contrat) => {
      const signataire = contrat.fkEtabEntrepriseClientSignataire
      const address = signataire?.adresses?.[0] ?? contrat.adresses?.[0]

      const name =
        signataire?.raisonSociale ??
        signataire?.nom ??
        contrat.raisonSociale ??
        contrat.nom ??
        ''
      const numeroContratSAP =
        contrat.numeroContratSAP ??
        contrat.idFonctionnelContrat ??
        contrat.numClient ??
        ''

      return {
        id: String(contrat.idContrat),
        name,
        siret: signataire?.codeSiret ?? contrat.codeSiret ?? '',
        address: `${address?.rueAdresse ?? ''} ${
          address?.codePostalAdresse ?? ''
        } ${address?.villeAdresse ?? ''}`,
        villeCP: `${address?.codePostalAdresse ?? ''} - ${
          address?.villeAdresse ?? ''
        }`,
        shortAdress: `${address?.rueAdresse ?? ''} `,
        numeroContratSAP,
      }
    })
  }
}

export default new ContractNormalizer()
